import { Directive } from "@angular/core";

@Directive({
	selector: "[stagesCardTitle]",
	standalone: true,
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class CardTitleDirective {}
